const HighlightColours = {
  colours: [
    // green teal
    "rgb(6,214,160)",
    // cyan green
    "rgb(27, 154, 170)",
    // rosey
    "rgb(239, 71, 111)",
    // orange
    "rgb(242, 133, 0)",
    // roal purple
    "rgb(84, 59, 164)",
    // magenta
    "rgb(176, 37, 174)",
    // ocean blue
    "rgb(68, 124, 255)",
    // puke green
    // 'rgb(152, 211, 157)',
    // green
    "rgb(84, 149, 84)",
    // poop
    "rgb(194, 132, 122)",
    // fluro yellow-green
    "rgb(171, 235, 52)",
    // red
    "rgb(200, 22, 68)",
    // cyan
    "rgb(67, 152, 204)",
  ],

  kvColors: [
    // orange & purple
    "rgb(255, 196, 61)",
    // 'rgb(176, 37, 174)',
    // initial
    // 'rgb(177, 193, 202)',
    // 'rgb(193, 185, 168)',
    // updated
    // 'rgb(244, 228, 217)',
    // 'rgb(236, 242, 253)',
  ],

  caclIndex(index: number): number {
    return index % this.colours.length;
  },

  getColor(index: number): string {
    return this.colours[index % this.colours.length];
  },

  getHighlightColor(index: number, transparency?: number): string {
    let c: string = this.colours[index % this.colours.length];
    c = `${c.substr(0, c.length - 1)}, ${transparency ?? 0.5})`;
    return c;
  },

  getKvColor(index: number, transparency?: number): string {
    let c: string = this.kvColors[index % this.kvColors.length];
    c = `${c.substr(0, c.length - 1)}, ${transparency ?? 0.5})`;
    return c;
  },

  getKvKeyColor(): string {
    return this.getKvColor(0);
  },
};

export { HighlightColours };
